import React, { type FC } from "react";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import Button from "../../../../../../shared-components/css-modules/lexus/atoms/Button";
import Icon from "../../../../../../shared-components/css-modules/lexus/atoms/Icon";
import styles from "./NoResults.module.scss";
import { clearFilters } from "../../../../../redux/slices/GradeSelectorFiltersSlice";
import { trackResetFilters } from "../../../../../utils/tracking";
import { useGradeSelectorDispatch } from "../../../../../redux/hooks";
import Container from "../../../../../../shared-components/css-modules/lexus/atoms/Container";
import { GradeSelectorLabel, useGradeSelectorLabel } from "../../../../../utils/labels";

const NoResults: FC = () => {
    const dispatch = useGradeSelectorDispatch();
    const gradeSelectorNoResultsTitle = useGradeSelectorLabel("gradeSelectorNoResultsTitle");
    const gradeSelectorNoResultsSubtitle = useGradeSelectorLabel("gradeSelectorNoResultsSubtitle");

    return (
        <Container className={styles.noResultsContainer}>
            <Text variant="apheleia-h4">{gradeSelectorNoResultsTitle}</Text>
            <Text variant="apheleia-body-large">{gradeSelectorNoResultsSubtitle}</Text>
            <Button
                onClick={() => {
                    dispatch(clearFilters());
                    trackResetFilters();
                }}
                className={styles.reset}
                variant="btn-secondary"
                sizing="pill"
            >
                <Icon variant="trash" sizing="sm" />
                <GradeSelectorLabel label="gradeSelectorNoResultsButton" />
            </Button>
        </Container>
    );
};

export default NoResults;
